module.exports = __webpack_public_path__ + "img/1.eea730ab.png";